import { Box, Skeleton } from "@mui/material";
import "../../styles/material.css";
import "../../styles/styles.css";

const InboxSkeleton = ({ noTop }: any) => {
  return (
    <Box className={`inboxContentContainer ${noTop && "mar-t-2"}`}>
      {Array.from({ length: Math.floor(window.innerHeight / 72) }).map((k: any, i: number) => {
        return (
          <Box key={i} className="flexbox flex-space-between" sx={{ padding: "12px 16px" }}>
            <Skeleton variant="circular" width={48} height={48} />
            <Box className="flex-direction-column flex-grow mar-l-12">
              <Skeleton variant="rounded" width="65%" height={24} />
              <Skeleton className="mar-t-4" variant="rounded" width="90%" height={24} />
            </Box>
            <Box className="flex-align-self-end">
              <Skeleton variant="rounded" width={24} height={24} />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default InboxSkeleton;
